import { useEffect, useState } from "react";
import { setNotifFunction } from "./notificationManager";

function NotificationPopup() {
  const [message, setMessage] = useState(null);

  //   useEffect(() => {
  //     const handleNotification = (msg) => {
  //       setMessage(msg);
  //       setTimeout(() => setMessage(null), 3000); // Auto-dismiss after 3 seconds
  //     };

  //   }, []);

  useEffect(() => {
    setNotifFunction(setMessage);
  }, []);

  return (
    message && (
      <div
        className="notification_pop"
        style={{
          position: "fixed",
          top: "10px",
          left: "50%",
          transform: "translateX(-50%)",
          padding: "10px",
          background: "#f0c040",
          borderRadius: "5px",
          zIndex: 9999,
        }}
      >
        {message}
      </div>
    )
  );
}

export default NotificationPopup;
